import * as React from 'react';

import {Dialog} from 'shells/dialog/dialog';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {MfaRecoveryCodes} from 'shells/mfa/mfa-recovery-codes';

import {regenerateMfa, getBackupCodes} from '../../../auth/utils';

import type {Method} from '../types';
import {MfaBody} from '../typography/index';

import styles from './recovery-codes.module.css';

type Props = {
    onNextReady?: () => void;
    onNextNotReady?: () => void;
    method: Method;
};

export function RegenerateRecoveryCodesScreen(props: Props) {
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isConfirmingRegenerate, setIsConfirmingRegenerate] = React.useState<boolean>(false);
    const [recoveryCodes, setRecoveryCodes] = React.useState([]);
    const [usedRecoveryCodes, setUsedRecoveryCodes] = React.useState([]);

    const regenerateCodesButton = React.useRef(null);

    const {method} = props;

    React.useEffect(() => {
        setIsLoading(true);

        // @ts-expect-error
        const fetchedCodes = [];
        // @ts-expect-error
        const usedCodes = [];

        getBackupCodes().then((result) => {
            // @ts-expect-error
            result.backupCodes.forEach((code) => {
                if (code.used) {
                    usedCodes.push(code.code);
                } else {
                    fetchedCodes.push(code.code);
                }
            });

            // @ts-expect-error
            setRecoveryCodes(fetchedCodes);
            // @ts-expect-error
            setUsedRecoveryCodes(usedCodes);

            setIsLoading(false);
        });
    }, [method]);

    const generateNewCodes = () => {
        setIsLoading(true);
        regenerateMfa({mfaType: '2'}).then((result) => {
            setRecoveryCodes(result.result);
            setUsedRecoveryCodes([]);
            setIsLoading(false);
        });
    };

    return (
        <>
            <StackLegacy spacing={12}>
                <MfaBody>
                    <b>Save or download these recovery codes</b> to get back into your Nutshell
                    account if your phone gets lost or stolen. Codes that are crossed out have
                    already been used.
                </MfaBody>

                <MfaBody>
                    If you generate a new set of codes, make sure to save them somewhere.
                </MfaBody>

                <div className={styles['mfa-codes']}>
                    <MfaRecoveryCodes
                        isLoading={isLoading}
                        codes={recoveryCodes}
                        usedCodes={usedRecoveryCodes}
                        onCodesSaved={props.onNextReady}
                        showRegenerateButton={true}
                        generateNewCodes={() => {
                            setIsConfirmingRegenerate(true);
                        }}
                        // @ts-expect-error
                        getRegenerateButtonRef={(ref) => {
                            if (ref) {
                                regenerateCodesButton.current = ref;
                            }
                        }}
                    />
                </div>
            </StackLegacy>
            {isConfirmingRegenerate ? (
                <Dialog
                    anchor={regenerateCodesButton.current}
                    question={`Are you sure you’d like to generate a new set of recovery codes? This will make your old codes invalid.`}
                    onPrimary={() => {
                        generateNewCodes();

                        if (props.onNextNotReady) {
                            props.onNextNotReady();
                        }

                        setIsConfirmingRegenerate(false);
                    }}
                    onSecondary={() => {
                        setIsConfirmingRegenerate(false);
                    }}
                    isSave={true}
                    primaryText='Yes, generate new codes'
                    secondaryText='Cancel'
                    location='bottom'
                />
            ) : null}
        </>
    );
}
